import { formatDistanceToNow, subMonths } from 'date-fns';

export { BADGE_SUBMISSION_URL, NEW_PASTE_URL } from 'config/data-sources';

/** Returns the cutoff Date for feed updates — activity older than this is excluded. */
export const getFeedUpdatesCutoffDate = () => subMonths(new Date(), 3);

export const AN_HOUR_MS = 60 * 60 * 1000;
/** Window for collapsing same-person feed bursts into one card. */
export const FEED_BURST_MS = 12 * AN_HOUR_MS;

/** Human-readable last-updated string. Shows "recently" for updates within the last hour. */
export const formatLastUpdated = (date: Date): string => {
  if (new Date().getTime() - date.getTime() < AN_HOUR_MS) return 'recently';
  return formatDistanceToNow(date, { addSuffix: true });
};

/** Award emojis used in leaderboard rankings (1st, 2nd, 3rd). */
export const awardEmojis = ['🥇', '🥈', '🥉'] as const;

/** Converts a 1-based rank to a medal emoji or "#N" string. */
export const getRankDisplay = (rank: number): string => (rank >= 1 && rank <= 3 ? awardEmojis[rank - 1] : `#${rank}`);

/** Default logo image URL. */
export const talosBadgesLogoURL = `${process.env.PUBLIC_URL}/images/talos-badges-logo.png`;

/** App favicon — root-absolute so nested routes don’t resolve `favicon.ico` relative to the path. */
export const talosBadgesFaviconURL = `${process.env.PUBLIC_URL}/favicon.ico`;

// Warm the loading-spinner icon as early as this module evaluates (before React effects).
if (typeof Image !== 'undefined') {
  const warmFavicon = new Image();
  warmFavicon.src = talosBadgesFaviconURL;
}
